import { Injectable, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { urls, strings, CONTAS } from './../../../../../environments/environment';
import * as md5 from 'blueimp-md5';
import { LocalStorageService } from './../../local-storage/local-storage.service';
import { Observable } from 'rxjs';
import { AuthorizationData, IChangePassword } from './login.interface';
import { map } from 'rxjs/operators';

@Injectable()
export class LoginService {
  headers: HttpHeaders;

  constructor(
    private http: HttpClient,
    private router: Router,
    private localStorageService: LocalStorageService
  ) { }

  addHeaders() {
    this.headers = new HttpHeaders();
    const loginObject = this.localStorageService.get('login');
    this.headers = this.headers.set('Authorization', 'Bearer ' + loginObject.Token);
  }

  login(email, password): Observable<AuthorizationData> {
    const data = {
      Email: email,
      AppSource: 'paguela',
      Password: md5(email + password),
    };

    return this.http
      .post(urls.user_service + '/Auth/Login', data);
  }

  refreshToken(refreshToken) {
    const data = {
      TokenId: refreshToken,
      AppSource: 'paguela',
    };

    return this.http
      .post(urls.user_service + '/Auth/Refresh', data);
  }

  logOut() {
    this.localStorageService.set('login', null);
    this.router.navigate(['/login']);
  }

  getUserData() {
    return this.http
      .get(urls.apiBaseActuar + '/accoounts/user', { withCredentials: true });
  }

  public changePassword(data: IChangePassword): Observable<any> {
    this.addHeaders();

    return this.http
      .post(`${urls.user_service}/Auth/ChangePassword`, data, {
        headers: this.headers,
        withCredentials: false
    });
  }

  isAdmin(): boolean {
    const loginData = this.localStorageService.get('login');
      if (loginData.PersonId) {
       return loginData.PersonId === CONTAS.ACTUAR_CONTAID ||
              loginData.PersonId === CONTAS.TOLETUS_CONTAID ||
              loginData.PersonId === CONTAS.PAGUELA_CONTAID;
      }
    return false;
  }

  public generateLoginCode(): Observable<Object> {
    this.addHeaders();
    return this.http.post(`${urls.user_service}/Auth/GenerateLoginCode`, {}, {
      headers: this.headers,
      withCredentials: false
    });
  }

  public loginByCodeTemp(data: any): Observable<any> {
    this.localStorageService.set('login', null);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json');

    return this.http.post(urls.user_service + '/Auth/LoginByCodeTemp', data, {
      headers: headers,
      withCredentials: false
    }).pipe(map((res: any) => {
      if (res && Array.isArray(res)) { return res; }
      if (res && (res.emailConfirmed === false || res.phoneConfirmed === false)) { return res; }
      this.localStorageService.set('login', res);
      return res;
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth/login/login.service.ts